export default __webpack_public_path__ + "static/media/T22.cee961a1.png";